var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaelanoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 26,
    viewBox: "0 0 161 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7723_193726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.4098H4.84566V13.1759L10.3731 20.88L12.4015 20.8221L17.9825 13.5872V25.4098H22.8V0.500377H21.5688L12.2635 14.0533H11.4014L0.602891 0.03125L0 0.677061V25.4098Z",
    fill: "#3E5859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3093 0.707031L24.3896 25.4093H29.2325L40.2367 0.707031H35.3093Z",
    fill: "#3E5859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5262 14.8242L43.1945 25.41H37.5262L34.8188 19.3236L37.5262 14.8242Z",
    fill: "#3E5859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3435 0.707031V25.4093H62.1626V20.7333H48.9413V15.5272H60.6835V11.2045H49.1047V5.73644H62.1626V0.707031H44.3435Z",
    fill: "#3E5859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2681 0.707031V25.4093H84.0872V20.5566H71.1954V0.707031H66.2681Z",
    fill: "#3E5859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8782 25.4093L98.5388 0.707031H100.1L111.43 25.4093H106.01L99.1557 10.2358L95.3355 17.9977L101.249 18.1744L101.167 22.4971L92.955 22.5854L91.6421 25.4093H86.8782Z",
    fill: "#3E5859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.073 0V25.409H117.752L118.082 11.8226L132.78 25.409L133.109 0.706737H128.675L128.757 14.6465L113.073 0Z",
    fill: "#3E5859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.959 0.117188C142.307 0.117188 136.915 5.91121 136.915 13.0578C136.915 17.0149 138.572 20.5608 141.178 22.9338L143.826 18.0049C142.73 16.692 142.062 14.9556 142.062 13.0578C142.062 8.96358 145.15 5.64619 148.962 5.64619C152.774 5.64619 155.858 8.96358 155.858 13.0578C155.858 17.152 152.771 20.4694 148.962 20.4694C148.81 20.4694 148.663 20.4663 148.517 20.4511L145.784 25.5414C146.798 25.84 147.86 25.9984 148.962 25.9984C155.613 25.9984 161.003 20.2044 161.003 13.0578C161.003 5.91121 155.608 0.117188 148.959 0.117188Z",
    fill: "#3E5859"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7723_193726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaelanoColor);
export default __webpack_public_path__ + "static/media/maelano-color.381e132d40ff14eaf2c178c1f5476349.svg";
export { ForwardRef as ReactComponent };